import styled from 'styled-components'
import tw, { classnames, backgroundColor, inset, position, height } from 'tailwindcss-classnames';

export const Container = styled.footer.attrs({
    className: classnames(backgroundColor('bg-gpas-600' as any, 'dark:bg-gpas-700' as any), inset('bottom-0'), position('relative'), height('h-10'))
})`width: 100%;`;
